import * as React from "react"

const FlyingBoxes = props => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x={0}
    y={0}
    viewBox="0 0 1133.2 315.4"
    style={{
      enableBackground: "new 0 0 1133.2 315.4",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style>
      {".st0{fill:#3a4c60}.st2{fill:#b1da00}.st3{fill:#fff}.st4{fill:#007f6e}"}
    </style>
    <path
      className="st0"
      d="m0 315.4 75.7-46.8V0L0 46.7zM1133.2 315.4l-75.7-46.8V0l75.7 46.7z"
    />
    <defs>
      <path id="SVGID_1_" d="M9.8 91.2h1113v172.9H9.8z" />
    </defs>
    <clipPath id="SVGID_00000016056697336136137480000004707162387538574263_">
      <use
        xlinkHref="#SVGID_1_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath:
          "url(#SVGID_00000016056697336136137480000004707162387538574263_)",
      }}
    >
      <path className="st2" d="m192.8 121 12.7 47.5-34.8 34.9-12.7-47.6z" />
      <path className="st3" d="m110.4 143 34.8-34.8 47.6 12.8-34.8 34.8z" />
      <path className="st4" d="m110.4 143 12.8 47.5 47.5 12.8-12.7-47.5z" />
    </g>
    <g
      style={{
        clipPath:
          "url(#SVGID_00000016056697336136137480000004707162387538574263_)",
      }}
    >
      <path className="st2" d="m316.8 106.5 42.6 24.7v49.2l-42.6-24.6z" />
      <path className="st3" d="M274.1 180.4v-49.2l42.7-24.7v49.3z" />
      <path className="st4" d="m274.1 180.4 42.7 24.5 42.6-24.5-42.6-24.6z" />
    </g>
    <g
      style={{
        clipPath:
          "url(#SVGID_00000016056697336136137480000004707162387538574263_)",
      }}
    >
      <path className="st2" d="m440.8 121 47.6-12.8 34.8 34.8-47.6 12.8z" />
      <path className="st3" d="M462.9 203.4 428 168.5l12.8-47.5 34.8 34.8z" />
      <path className="st4" d="m462.8 203.3 47.6-12.8 12.8-47.5-47.6 12.8z" />
    </g>
    <g
      style={{
        clipPath:
          "url(#SVGID_00000016056697336136137480000004707162387538574263_)",
      }}
    >
      <path className="st2" d="m585.3 155.7 24.6-42.6h49.2l-24.6 42.6z" />
      <path className="st3" d="M659.1 198.4h-49.2l-24.6-42.7h49.2z" />
      <path className="st4" d="m659.1 198.4 24.6-42.7-24.6-42.6-24.6 42.6z" />
    </g>
    <g
      style={{
        clipPath:
          "url(#SVGID_00000016056697336136137480000004707162387538574263_)",
      }}
    >
      <path className="st2" d="M758.5 190.5 745.7 143l34.8-34.9 12.8 47.6z" />
      <path className="st3" d="M840.9 168.4 806 203.3l-47.5-12.8 34.8-34.8z" />
      <path className="st4" d="M840.8 168.5 828 121l-47.5-12.8 12.8 47.5z" />
    </g>
    <g
      style={{
        clipPath:
          "url(#SVGID_00000016056697336136137480000004707162387538574263_)",
      }}
    >
      <path className="st2" d="m952.1 204.9-42.6-24.6v-49.2l42.6 24.6z" />
      <path className="st3" d="M994.8 131.1v49.2l-42.7 24.6v-49.2z" />
      <path className="st4" d="m994.8 131.1-42.7-24.6-42.6 24.6 42.6 24.6z" />
    </g>
    <g
      style={{
        clipPath:
          "url(#SVGID_00000016056697336136137480000004707162387538574263_)",
      }}
    >
      <path className="st2" d="M1133.2 155.7v42.7h-46.9l24.6-42.7z" />
      <path className="st3" d="M1086.3 113.1h46.9v42.6h-22.3z" />
      <path className="st4" d="m1086.3 113.1-24.5 42.6 24.5 42.7 24.6-42.7z" />
    </g>
    <g
      style={{
        clipPath:
          "url(#SVGID_00000016056697336136137480000004707162387538574263_)",
      }}
    >
      <path className="st2" d="m-.9 155.7.7-.3v43h23.9l24.6-42.7z" />
      <path
        className="st3"
        d="m48.3 155.7-24.6-42.6H0v42.6h-.9zM48.3 155.7H-.9z"
      />
    </g>
  </svg>
)

export default FlyingBoxes
